exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".text-profile[data-v-6557cad8]{font-weight:500;font-size:17px}.bold[data-v-6557cad8]{font-weight:700}strong[data-v-6557cad8]{font-weight:600}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/customer/Detail.vue"],"names":[],"mappings":"AACA,+BACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,uBACE,eAAkB,CACnB,AACD,wBACE,eAAiB,CAClB","file":"Detail.vue","sourcesContent":["\n.text-profile[data-v-6557cad8] {\n  font-weight: 500;\n  font-size: 17px;\n}\n.bold[data-v-6557cad8] {\n  font-weight: bold;\n}\nstrong[data-v-6557cad8] {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6557cad8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/customer/Detail.vue
// module id = 2053
// module chunks = 0